import React, { useCallback, useEffect } from "react";
import { Card, Row, Col, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../branchTransferListSlice";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { SearchOutlined } from "@ant-design/icons";
import {
  fetchBranchTransferList,
  fetchBranchesBySearch,
} from "../branchTransferListThunk";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const BranchTransferFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.branchTransferList);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      const fromDate = searchParams.get("fromDate") || null;
      const nextFilters = { ...filters, fromDate, toDate: path };
      dispatch(setFilters({ fromDate, toDate: path }));
      dispatch(fetchBranchTransferList({ filters: nextFilters }));
    }
  }, []);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleSubmit = () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(fetchBranchTransferList({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  const searchBranch = useCallback(
    (text) => dispatch(fetchBranchesBySearch(text)),
    [dispatch]
  );

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap
        style={{ alignItems: "center" }}
      >
        {/* Filter Type */}
        <Col xs={24} sm={12} md={4} lg={6} xl={4}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[{ sale_id: "All", display_text: "All" }]}
            value={
              filters.filterType
                ? { value: filters.filterType, label: filters.filterType }
                : undefined
            }
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("filterType", null);
                return;
              } 
              handleFilterChange("filterType", obj?.sale_id);
            }}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {/* Branch */}
        <Col xs={24} sm={12} md={4} lg={6} xl={4}>
          <label>By Branch</label>
          <SearchListAutoComplete
            entityType="branch"
            searchThunk={searchBranch}
            resultSelector={(state) => state.branchTransferList.branches}
            onSelect={(obj) => handleFilterChange("branchId", obj?.sale_id)}
            placeholder="Branch"
            showAddNew={false}
          />
        </Col>

        {/* Date Filter */}
        <CommonDateRangeFilter
        filters={filters}
        onChange={(fromDate, toDate) => {
        handleFilterChange("fromDate", fromDate);
        handleFilterChange("toDate", toDate);
        }}
      />

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Get Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
      @media (min-width: 768px) {
  :where(.css-dev-only-do-not-override-1j5i8gz).ant-col-md-4 {
    max-width: none !important;
    flex: none !important;
  }
}

  `}</style>
    </Card>
  );
};

export default BranchTransferFilters;
